const DEF_DECIMAL_LENGTH = 2

export const numberUtils = {
  formatDecimal (value) {
    if (isNaN(value)) {
      return ''
    } else {
      const index = value.indexOf('.')
      if (index > -1 && value.length - index > 2) {
        return String(Number(value).toFixed(2))
      }
      return value
    }
  },
  replacer (match, p1, p2, p3, offset, string) {
    // p1 is leadingZero, p2 digits, and p3 is .xx
    return [p2, p3].join('')
  },
  convertToAlphabet (num) {
    var s = ''
    while (num > 0) {
      var m = num % 26
      if (m === 0) m = 26
      s = (m + 9).toString(36) + s
      num = (num - m) / 26
    }
    return s.toUpperCase()
  },
  getNumberFree (n = '', decimalLength = DEF_DECIMAL_LENGTH) {
    const numberFree = /^(?<symbol>=[<>]?|[<>]=?)?(?<integer>[^=<>.]+)(\.(?<decimal>[^=<>.]+))?$/
    const matches = numberFree.exec(n.toString())
    if (!matches) return
    let { symbol = '=', integer: strInt, decimal: strDecimal = '0' } = matches.groups
    const integer = strInt.replace(/[\s,]/g, '')
    if (integer.length === 0) return
    const decimal = strDecimal.replace(/[\s,]/g, '') || '0'
    if (/\D/.test(integer) || /\D/.test(decimal)) return
    const curDecimal = decimal.substring(0, decimalLength < 0 ? DEF_DECIMAL_LENGTH : decimalLength)
    const number = Number(`${integer}.${curDecimal}`)
    if (isNaN(number)) return
    return {
      symbol,
      number,
      integer,
      decimal: curDecimal,
      matches: matches.groups,
    }
  },
  /**
   * @param {string|string} target
   * @param {string|string} n
   * @param {number} [decimalLength]
   * @returns {boolean}
   */
  compareNumberFree (target, n, decimalLength) {
    if (
      (typeof target === 'string' && isNaN(Number(target))) ||
      (typeof target === 'number' && isNaN(target)) ||
      (typeof target !== 'string' && typeof target !== 'number')
    ) {
      return false
    }

    const targetValue = Number(target)
    const numberFreeObj = numberUtils.getNumberFree(n, decimalLength)
    if (!numberFreeObj) return false
    const { symbol, number } = numberFreeObj
    switch (symbol) {
      case '=':
        return targetValue === number
      case '>':
        return targetValue > number
      case '<':
        return targetValue < number
      case '>=':
        return targetValue >= number
      case '<=':
        return targetValue <= number
      default:
        return false
    }
  },
}

export default numberUtils
